'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var alloyGridList_module = require('./alloy-grid-list.module.scss.js');
var reactI18next = require('react-i18next');
var cx = require('classnames');
var withAnalytics = require('../../withAnalytics.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var GridList = function (_a) {
    var _b = _a.children, children = _b === void 0 ? [] : _b, className = _a.className, showCount = _a.showCount, buttonLabel = _a.buttonLabel; _a.analyticsEvents; var onLoad = _a.onLoad, props = tslib.__rest(_a, ["children", "className", "showCount", "buttonLabel", "analyticsEvents", "onLoad"]);
    var t = reactI18next.useTranslation().t;
    var childrenArray = react.Children.toArray(children);
    var _c = react.useState(1), loadMoreCount = _c[0], setLoadMoreCount = _c[1];
    var lastTile = showCount ? loadMoreCount * showCount : childrenArray.length;
    var displayChildren = childrenArray.slice(0, lastTile);
    var showLoadMore = showCount && childrenArray.length > displayChildren.length;
    var gridListClasses = cx__default.default("".concat(alloyGridList_module.default['grid-list']), "".concat(className ? " ".concat(className) : ''));
    react.useEffect(function () {
        if (onLoad) {
            var endIndex = displayChildren.length - 1;
            onLoad({ endIndex: endIndex });
        }
    }, [displayChildren, onLoad]);
    return (jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "grid-list", className: gridListClasses }, props, { children: jsxRuntime.jsxs("div", tslib.__assign({ className: "container" }, { children: [jsxRuntime.jsx("div", tslib.__assign({ className: "row" }, { children: displayChildren })), showLoadMore && (jsxRuntime.jsx("div", tslib.__assign({ className: "row" }, { children: jsxRuntime.jsx("div", tslib.__assign({ className: "col text-center" }, { children: jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ buttonType: "secondary", size: "large", onClick: function () {
                                return setLoadMoreCount(function (prev) { return prev + 1; });
                            } }, { children: buttonLabel ? buttonLabel : t('LOAD_MORE') })) })) })))] })) })));
};
var exportComponent = withAnalytics.withAnalytics(GridList);
exportComponent.displayName = GridList.name;

exports.GridList = GridList;
exports.default = exportComponent;
//# sourceMappingURL=GridList.js.map
